const saleSystemBaseUrl = 'https://saleapp-nodejs-reactjs.herokuapp.com';

export {
    saleSystemBaseUrl
}